// @ts-nocheck
/* eslint-disable */
import { CONFIG } from "~/config";

/**
 * Trida pro nacitani detailu mapyboxu a komunikaci s historii
 */
(function() {

	Mapy.SIDCurator = {};
	Mapy.SIDCurator.getSIDFromData = data => {
		const MAX_URL_LENGTH = Mapy.CUS.history && Mapy.CUS.history.sid ? Mapy.CUS.history.sid : 1024;

		return new Promise((resolve, reject) => {
			let componentData = JSON.parse(JSON.stringify(data));
			let urlLength = (CONFIG.mapyURL + Mapy.getComponent("history").serialize(componentData)).length;

			if (urlLength > MAX_URL_LENGTH) {
				delete componentData.x;
				delete componentData.y;
				delete componentData.z;
				delete componentData.mapset;
				delete componentData.box;

				Mapy.ProviderSID.getSID(Mapy.getComponent("history").serialize(componentData, true)).then(sid => {
					if ("sid" in sid && sid.sid != "") {
						let newData = {
							x: data.x,
							y: data.y,
							z: data.z,
							sid: sid.sid,
							mapset: data.mapset
						}

						if ("box" in data) {
							newData.box = data.box;
						}

						resolve(newData);
					}
				}, e => {
					reject(e);
				});
			}
			else {
				reject();
			}
		});
	};
}());
